// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__PzYR0","navIcon":"Navigation_navIcon__2uu-u","active":"Navigation_active__I4QSp","footer":"Navigation_footer__d9UWb"};